module.exports = __webpack_public_path__ + "img/serviceAward.d1cf2147.jpg";